import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const recordUnauthorizedAccess = async (email, page, ip) => {
  try {
    const data = JSON.stringify({
      svc: "logs",
      pid: "unauthroizedAccess",
      dat: {
        email: email,
        page: page,
        ip: ip,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getIp = async () => {
  let ip = await axios.get("https://api.ipify.org/?format=json");
  let ipAddress = ip.data.ip;
  return ipAddress;
};
